import React from 'react';
import { C } from '../styles/theme';

export function LoadingSpinner({ size = 32 }: { size?: number }): React.ReactElement {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 48 }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `3px solid ${C.border}`,
          borderTopColor: C.primary,
          animation: 'spin 0.7s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function PageError({ message }: { message: string }): React.ReactElement {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: 64, gap: 8, color: C.text2,
    }}>
      <span style={{ fontSize: 32 }}>⚠️</span>
      <span style={{ fontSize: 14 }}>{message}</span>
    </div>
  );
}
